import AnalyticsDataFetcher from 'zoomforth_analytics/data_fetcher.js';

var singleton;

const init = () => {
  singleton = new AnalyticsDataFetcher();
  return singleton;
};

const get = () => {
  if (!singleton) {
    throw new Error('You must call `init` on appglobal singleton before calling `get`');
  }

  return singleton;
};

export { get, init };
export default { get, init };